import { table } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'table',
  label: 'Table',
  category: 'Data Display',
  image: table,
};
